// extracted by mini-css-extract-plugin
export default {"textarea":"styles_textarea__2cIfh","error":"styles_error__rb2AH","textWrapper":"styles_textWrapper__2j5WG","text":"styles_text__cxVwD","link":"styles_link__6RF8m"};